import { PlaybookTabLayout } from '../PlaybookTabLayout';
import { ActivityOverview } from './ActivityOverview';
import { AssetsTable } from './AssetsTable';
import { DetailsCard } from './DetailsCard';

export const OverviewTab = () => {
  return (
    <PlaybookTabLayout>
      <div className="w-full flex flex-col gap-6">
        <div className="flex gap-6">
          <div className="flex-1">
            <DetailsCard />
          </div>
          <div className="flex-1">
            <ActivityOverview />
          </div>
        </div>
        <div className="pb-10">
          <AssetsTable />
        </div>
      </div>
    </PlaybookTabLayout>
  );
};
